import React from "react";
import { Link } from "react-router-dom";

// IMPORT IMAGES
import img02 from "../../images/project/img1.jpg";
import img03 from "../../images/project/img2.png";
import img04 from "../../images/project/img3.png";
import img05 from "../../images/project/img4.png";
import img06 from "../../images/project/img5.png";
import img07 from "../../images/project/img6.png";
import img08 from "../../images/project/img7.png";
import img09 from "../../images/project/img8.png";

// ARROW ICON SVG
const ArrowIcon = () => (
  <>
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>

    <svg width="25" height="25" viewBox="0 0 25 25" fill="none">
      <rect x="5.23" y="17.32" width="17.88" height="2.27" transform="rotate(-40.28 5.23 17.32)" fill="white" />
      <rect x="7.75" y="6.25" width="2.27" height="2.27" transform="rotate(-40.28 7.75 6.25)" fill="white" />
      <rect x="10.95" y="6.52" width="2.27" height="2.27" transform="rotate(-40.28 10.95 6.52)" fill="white" />
      <rect x="14.16" y="6.78" width="2.27" height="2.27" transform="rotate(-40.28 14.16 6.78)" fill="white" />
      <rect x="17.09" y="10.25" width="2.27" height="2.27" transform="rotate(-40.28 17.09 10.25)" fill="white" />
      <rect x="16.83" y="13.45" width="2.27" height="2.27" transform="rotate(-40.28 16.83 13.45)" fill="white" />
      <rect x="16.56" y="16.65" width="2.27" height="2.27" transform="rotate(-40.28 16.56 16.65)" fill="white" />
    </svg>
  </>
);

// PROJECT DATA
const projectData = [
  {
    title: "Amusement Park Management System",
    content:
      "We build intelligent Amusement Park Management Systems that streamline operations and enhance visitor experience. From ticketing and ride management to crowd monitoring and smart scheduling, our solutions automate park activities, reduce operational workload, and ensure a seamless, enjoyable experience for every guest.",
    images: [img02, img02, img02, img02],
    reverse: false,
  },
  {
    title: "Resort Management System",
    content:
      "We deliver Resort Management Systems that streamline operations, enhance guest experience, and enable smarter decision-making. From booking automation to service management and real-time insights, our solutions are built to simplify workflows and elevate every aspect of resort operations.",
    images: [img03, img03, img03, img03],
    reverse: true,
  },
  {
    title: "Restaurant Management System",
    content:
      "We develop Restaurant Management Systems that simplify daily operations, optimize service flow, and enhance customer experience. From order processing to inventory tracking and performance insights, our solutions help restaurants improve accuracy, efficiency, and overall decision-making.",
    images: [img04, img04, img04, img04],
    reverse: false,
  },
  {
    title: "Business ERP Solution",
    content:
      "We build Business ERP solutions that unify operations, automate workflows, and provide real-time visibility across departments. From finance to inventory and HR management, our systems help businesses streamline processes, reduce errors, and make smarter data-driven decisions.",
    images: [img05, img05, img05, img05],
    reverse: true,
  },
  {
    title: "Advanced Accounting System",
    content:
      "We develop Advanced Accounting Systems that simplify financial management, ensure accuracy, and enhance decision-making. From automated bookkeeping to real-time reporting and smart analytics, our solutions help businesses stay compliant, reduce manual errors, and maintain complete control over their finances.",
    images: [img06, img06, img06, img06],
    reverse: false,
  },
  {
    title: "Medical Management system",
    content:
      "We create Medical Management Systems that streamline clinical workflows, enhance patient care, and improve operational efficiency. From appointment scheduling and electronic health records to billing automation and real-time insights, our solutions help healthcare providers deliver safer, faster, and smarter medical services.",
    images: [img07, img07, img07, img07],
    reverse: true,
  },
  {
    title: "Farm House Management System",
    content:
      "We develop Farm House Management Systems that bring clarity, control, and convenience to property operations. With tools for smart reservations, staff coordination, maintenance tracking, and guest services, our system helps farmhouses run smoothly while creating a peaceful, hassle-free experience for every visitor.",
    images: [img08, img08, img08, img08],
    reverse: false,
  },{
    title: "Construction Management System",
    content:
      "We deliver Construction Management Systems that optimize project planning, resource allocation, and operational oversight. By providing real-time insights, workflow automation, and comprehensive reporting, our solutions help construction firms enhance efficiency, reduce risks, and execute projects with precision and accountability.",
    images: [img09, img09, img09, img09],
    reverse: true,
  },
];

const ProjectSection: React.FC = () => {
  return (
    <section className="service pos-rel mt-75">
      <div className="container mxw-1650">
        <div className="xb-project-wrap xb-project-wrap_2">

          {projectData.map((item, index) => (
            <div className="xb-project-item" key={index}>
              {/* LEFT TEXT / RIGHT IMAGE or REVERSE */}
              {!item.reverse ? (
                <>
                  {/* CONTENT FIRST */}
                  <div className="xb-project-content">
                    <div className="xb-item--inner xb-border">
                      <h2 className="xb-item--title">{item.title}</h2>
                      <p className="xb-item--content clr-white">{item.content}</p>

                      {/* <div className="xb-item--btn mt-40">
                        <Link className="thm-btn agency-btn" to="/project-details">
                          <span className="text">read more</span>
                          <span className="arrow">
                            <span className="arrow-icon"><ArrowIcon /></span>
                          </span>
                        </Link>
                      </div> */}
                    </div>
                  </div>

                  {/* IMAGES */}
                  <div className="xb-project-img img-hove-effect">
                    <div className="xb-img">
                      {item.images.map((img, i) => (
                        <Link to="/project" key={i}>
                          <img src={img} alt="project" />
                        </Link>
                      ))}
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {/* REVERSED: IMAGE FIRST */}
                  <div className="xb-project-img img-hove-effect">
                    <div className="xb-img">
                      {item.images.map((img, i) => (
                        <Link to="/project" key={i}>
                          <img src={img} alt="project" />
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div className="xb-project-content">
                    <div className="xb-item--inner xb-border">
                      <h2 className="xb-item--title">{item.title}</h2>
                      <p className="xb-item--content clr-white">{item.content}</p>

                      {/* <div className="xb-item--btn mt-40">
                        <Link className="thm-btn agency-btn" to="/project-details">
                          <span className="text">read more</span>
                          <span className="arrow">
                            <span className="arrow-icon"><ArrowIcon /></span>
                          </span>
                        </Link>
                      </div> */}
                    </div>
                  </div>
                </>
              )}
            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default ProjectSection;
